import { render } from "./userule.vue?vue&type=template&id=2487a8b4&scoped=true"
import script from "./userule.vue?vue&type=script&lang=js"
export * from "./userule.vue?vue&type=script&lang=js"

import "./userule.vue?vue&type=style&index=0&id=2487a8b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2487a8b4"]])

export default __exports__